/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ voiceName: NonNullable<unknown> }} Voices_Select_Voice_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select voice {voiceName}" |
*
* @param {Voices_Select_Voice_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_select_voice_aria_label = /** @type {((inputs: Voices_Select_Voice_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Select_Voice_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Selectionner la voix ${i?.voiceName}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Stimme auswählen ${i?.voiceName}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Seleziona la voce ${i?.voiceName}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выберите голос ${i?.voiceName}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Seleccionar voz ${i?.voiceName}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`选择语音${i?.voiceName}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`音声を選択 ${i?.voiceName}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वॉइस ${i?.voiceName} चुनें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Selecione a voz ${i?.voiceName}`)
	return /** @type {LocalizedString} */ (`Select voice ${i?.voiceName}`)
});